module.exports = __webpack_public_path__ + "img/report-2.1d8c9d19.jpg";